document.addEventListener('DOMContentLoaded', function() {
  function initTolstoyAutoHide() {
    let carousels = document.querySelectorAll('tolstoy-carousel[data-auto-hide="true"]');
    
    carousels.forEach(function(carousel) {
      if (carousel.dataset.autoHideInitialized) return;
      carousel.dataset.autoHideInitialized = 'true';

      let wrapper = carousel.closest('.tolstoy-section-wrapper');
      if (!wrapper) return;

      function hasContent() {
        return carousel.querySelector(
          'video, iframe, [data-tolstoy-element*="carousel"], .tolstoy-carousel-container, .tolstoy-video-carousel-container'
        ) !== null;
      }

      function decideVisibility() {
        if (hasContent()) {
          wrapper.style.visibility = '';
          wrapper.style.height = '';
          wrapper.style.overflow = '';
        } else {
          wrapper.style.visibility = 'hidden';
          wrapper.style.height = '0';
          wrapper.style.overflow = 'hidden';
        }
      }

      let statusObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'data-status') {
            let newStatus = carousel.getAttribute('data-status');
            if (newStatus === 'loading' || newStatus === 'loaded' || newStatus === 'error') {
              decideVisibility();
            }
          }
        });
      });

      statusObserver.observe(carousel, { attributes: true, attributeFilter: ['data-status'] });
    });
  }

  initTolstoyAutoHide();
});
